<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M27.926 6.278l-5.761 20.446A1.75 1.75 0 0120.615 28h-.154a1.759 1.759 0 01-1.584-1l-3.925-8.294a.451.451 0 01.088-.505l5.64-5.643a.88.88 0 10-1.242-1.242l-5.64 5.653a.45.45 0 01-.506.088l-8.246-3.905A1.825 1.825 0 014 11.437a1.749 1.749 0 011.287-1.595L25.77 4.068a1.759 1.759 0 011.946.715 1.837 1.837 0 01.209 1.495z"/></svg>
</template>

<script>
export default {
  name: 'symbolsPaperPlaneTiltFilled'
}
</script>
